import React, { Fragment } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { BrandType } from '@nsw-paginas-deslogadas/constants'
import { useIsMountedRef } from '@nsw-paginas-deslogadas/hooks'
import { NotFound } from '@nsw-paginas-deslogadas/pages'
import { QueryParams } from '@nsw-paginas-deslogadas/router'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { Product } from '@nsw-paginas-deslogadas/typings'
import { getBrandFromParam } from '@nsw-paginas-deslogadas/utils'

type ContextRouteProps = RouteComponentProps<QueryParams> & { component: React.FC }

const ContextRoute: React.FC<ContextRouteProps> = ({ children, component: Component, ...props }) => {
    const { setContextStates } = useAppContext()
    const { isMounted } = useIsMountedRef()

    const { brand = 'nav', productId = 0, productName = '' } = props.match.params

    const brandFromParam = getBrandFromParam(brand) as BrandType
    const productFromParam = { id: Number(productId), name: productName } as Product

    !isMounted && setContextStates({ brand: brandFromParam, product: productFromParam })

    if (brandFromParam === null) {
        return <NotFound />
    }

    return <Fragment>{children || <Component />}</Fragment>
}

export default ContextRoute
